export enum ReportListType {
    AW = 0,
    AD = 1,
    W = 2,
    OW = 3,
    OD = 4,
    Standard = 5,
    Superwide = 6,
    Windload = 7,

    // subassembly lists
    AW_Standard = 8,
    AD_Standard = 9,
    W_Standard = 10,
    W_Windload = 11,
    W_Superwide = 12,
    OW_Standard = 13,
    OW_Superwide = 14,
    OD_Standard = 15,
    OD_Superwide = 16,
    D_Standard = 17,
    D_Superwide = 18,
    Nineties = 19
}

export enum ReportWindowsListType {
    EightyThreeStandard = 0,
    EightyThreeSuperwide = 1,
    RaisedPanelStandard = 2,
    RaisedPanelWindload = 3,
    FoamPackStandard = 4,
    FoamPackSuperwide = 5,
    RibStandard = 6,
    RibSuperwide = 7,
    AccentPack = 8,
    Impact = 9
}